import { render } from "./CustomSelect.vue?vue&type=template&id=53cb7c05&scoped=true"
import script from "./CustomSelect.vue?vue&type=script&lang=js"
export * from "./CustomSelect.vue?vue&type=script&lang=js"

import "./CustomSelect.vue?vue&type=style&index=0&id=53cb7c05&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53cb7c05"]])

export default __exports__